// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-people-index-js": () => import("./../src/components/People/index.js" /* webpackChunkName: "component---src-components-people-index-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

